import { ActionIcon } from "@mantine/core";

import { IconChevronDown, IconChevronUp } from "@/components/icons";

import type { MantineSize, ThemeIconVariant } from "@mantine/core";
import type { FC } from "react";

export type DropdownChevronProps = {
  disabled?: boolean;
  onClick?: () => void;
  opened?: boolean;
  size?: MantineSize;
  variant?: ThemeIconVariant;
};

export const DropdownChevron: FC<DropdownChevronProps> = ({
  disabled = false,
  onClick,
  opened = false,
  size,
  variant = "light",
}) => (
  <ActionIcon disabled={disabled} variant={variant} size={size} radius="sm" onClick={onClick}>
    {opened ? <IconChevronUp size={24} /> : <IconChevronDown size={24} />}
  </ActionIcon>
);
